// client/src/Spinner.js
import React from 'react';

const Spinner = () => (
  <div className="flex items-center justify-center w-24 h-24 bg-gray-200 rounded-md">
    <div className="w-6 h-6 border-4 border-blue-500 border-solid rounded-full border-t-transparent animate-spin"></div>
  </div>
);

export default Spinner;